import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import CollegeOptimizer from './app';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CollegeOptimizer />
  </React.StrictMode>
);